import { memo } from "react";
import { Button } from "components/buttons/Button";
import PlusIcon from "@/common/images/icons/plus.svg?react";
import { ManageLinkItem } from "components/manage/ManageLinkItem";
import { IAliasLink } from "@/common/services/types";
import "./ManageLinks.scss";

interface IManageLinks {
  aliasIds: IAliasLink[];
  onAddLink: () => Promise<void>;
}

export const ManageLinks: React.FC<IManageLinks> = memo(({
  aliasIds,
  onAddLink
}) => (
  <div className="ManageLinks">
    <h2 className="ManageLinks-Title">Manage Links</h2>
    <div className="ManageLinks-List">
      {aliasIds.map(({ id }: IAliasLink) => (
        <ManageLinkItem linkId={id} key={id} />
      ))}
      <div className="ManageLinks-Item">
        <Button variant="primary" size="s" round aria-label="Add Alias" onClick={onAddLink} type="button">
          <PlusIcon />
        </Button>
        <button className="AddAliasBtn" onClick={onAddLink} type="button">Add an Alias</button>
      </div>
    </div>
  </div>
));

